export const ATLASSIAN_ACCOUNT_ID = 'atlassian' as const;
